import {create} from './factory';

export const analyticsProxy = create();
